/* eslint-disable react/jsx-props-no-spreading */
import { Typography, useTheme } from "@material-ui/core";
import { useField } from "formik";
import React from "react";
import Select from "react-select";

const MultipleSelectField = ({ name, label, disabled, ...other }) => {
  const [field, , { setValue }] = useField(name);
  const onChange = value => {
    setValue(value);
  };
  const theme = useTheme();
  const disabledByRole = disabled;
  return (
    <div>
      {label && (
        <Typography gutterBottom>
          <strong>{label}</strong>
        </Typography>
      )}
      <Select
        value={field.value}
        onChange={onChange}
        isMulti
        menuPortalTarget={document.body}
        isDisabled={disabledByRole}
        styles={{
          menu: base => ({
            ...base,
            background: theme.palette.background.paper
          }),
          option: (base, { isFocused }) => ({
            ...base,
            backgroundColor: isFocused ? "rgba(0, 0, 0, 0.1)" : "rgba(0, 0, 0, 0)"
          }),
          menuPortal: base => ({
            ...base,
            zIndex: 9999
          })
        }}
        {...other}
      />
    </div>
  );
};

export default MultipleSelectField;
